export const storePromoImages = [
  {
    id: 4,
    tag: "BEST PRICES",
    tagColor: "blue",
    title: "Place your order today at the best price.",
    subtitle: "Competitive pricing on all essentials.",
    buttonText: "Shop Now",
    bgColor: "bg-blue-50",
    textColor: "text-blue-800",
    buttonColor: "bg-blue-500 hover:bg-blue-600",
  },
  {
    id: 5,
    tag: "BEST VALUE",
    tagColor: "green",
    title: "Enjoy free delivery on family orders.",
    subtitle: "Save more when you shop for the family.",
    buttonText: "Start Shopping",
    bgColor: "bg-green-50",
    textColor: "text-green-800",
    buttonColor: "bg-green-500 hover:bg-green-600",
  },
  {
    id: 6,
    tag: "FAST & RELIABLE",
    tagColor: "purple",
    title: "No queues, no delays, we deliver promptly.",
    subtitle: "Shop online and get it at your doorstep fast.",
    buttonText: "Make Bulk Order",
    bgColor: "bg-purple-50",
    textColor: "text-purple-800",
    buttonColor: "bg-purple-600 hover:bg-purple-700",
  },
];
